import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

const accountManagerUrl = "https://am.ticketmaster.com/redwings/";
const salesPhone = "3134717575";
const salesPhoneDisplay = "(313) 471-7575";

const linkSx = {
  color: "primary.main",
  textDecoration: "none",
  fontWeight: 500,
};

const SalesPhoneLink = () => (
  <Link href={`tel:${salesPhone}`} sx={linkSx}>
    {salesPhoneDisplay}
  </Link>
);

const Email = () => (
  <Link href={`mailto:drwgrouptickets@olyent.com`} sx={linkSx}>
    drwgrouptickets@olyent.com
  </Link>
);

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Game",
    description: "Select the game you wish to attend with your group.",
  },
  {
    icon: <TbShirtSport />,
    title: "Login to Account Manager",
    description: (
      <>
        Click Continue and connect to your{" "}
        <Link
          href={accountManagerUrl}
          target={"_blank"}
          sx={{
            color: "primary.main",
            textDecoration: "none",
            fontWeight: 500,
          }}
        >
          Detroit Red Wings
        </Link>{" "}
        account using our secure Ticketmaster login.
      </>
    ),
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for your group.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available to be managed in your{" "}
        <Link
          target={"_blank"}
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
          href={accountManagerUrl}
        >
          Detroit Red Wings
        </Link>{" "}
        Account Manager within 24 hours.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "What is a group ticket order?",
    description:
      "Bring your friends, family, coworkers, or classmates to the game. Group orders let you purchase seats together for the games you choose (subject to availability).",
  },
  {
    title: "What is the minimum number of tickets for a group?",
    description: "A minimum of 10 tickets is required per group order.",
  },
  {
    title: "What are the benefits of purchasing a group?",
    description:
      "A minimum of 10 tickets purchased unlocks the lowest ticket pricing while seating your group together.",
  },
  {
    title: "I'm looking to purchase 30+ tickets",
    description: (
      <>
        Email <Email /> or call <SalesPhoneLink /> to speak directly with a
        dedicated team member who will assist you in organizing group purchases
        of more than 30 tickets.
      </>
    ),
  },
  {
    title: "Can I transfer or resell my tickets if I can no longer attend?",
    description:
      "You may transfer your tickets as needed but resale is not permitted.",
  },
];

export function SeatCounterDescription() {
  return (
    <>
      Select the number of people in your group. For group purchases of 30+,
      please email <Email /> or call <SalesPhoneLink /> to speak directly with a
      dedicated team member.
    </>
  );
}

export function CheckoutTerms() {
  return (
    <>
      By purchasing you agree to receive SMS alerts regarding ticket delivery
      and agree to the{" "}
      <Link
        href={"https://www.attend.tech/terms-of-use"}
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Terms & Conditions
      </Link>{" "}
      and{" "}
      <Link
        href={"https://www.attend.tech/privacy-policy"}
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Privacy Policy
      </Link>
      .
    </>
  );
}
